var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeTerminal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "73.5398mm",
    height: "66.7245mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 643.22 583.61",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E85858",
    width: 643.22,
    height: 583.61,
    rx: 46.95,
    ry: 51.65
  }), /*#__PURE__*/React.createElement("g", {
    id: "bus.svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M476.26 285.05l-20.24 0 0 69.62 8.09 0 0 31.97 -15.38 0 0 -105.64c0.01,-21.46 -17.39,-38.85 -38.85,-38.85l-127.9 0c-21.45,0 -38.85,17.39 -38.85,38.85l0 103.61 -13.36 0 0 -34.01 8.5 0 0 -69.61 -20.23 0 0 69.61 8.5 0 0 37.25 16.59 0 0 76.09c0,14.7 8.18,27.51 20.24,34.1l0 20.11 33.99 0 0 -15.37 96.32 0 0 15.37 34.01 0 0 -19.73c12.49,-6.44 21.04,-19.47 21.04,-34.5l0 -74.08 18.62 0 0 -35.2 8.91 0 0 -69.62 0 0zm-174.84 -34.81l90.65 0 0 21.06 -90.65 0 0 -21.06zm9.71 212.09l-50.18 0 0 -22.65 50.18 0 0 22.65zm121.42 0l-50.18 0 0 -22.65 50.18 0 0 22.65zm0 -72.85c0,0 -9.71,30.77 -87.42,30.77 -77.71,0 -85.81,-30.77 -85.81,-30.77l0 -106.86 173.23 0 0 106.86z"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("polygon", {
    fill: "black",
    points: "82.41,518.18 134.25,518.18 134.25,195.31 560.8,195.31 560.8,65.43 82.41,65.43 82.41,88.66 82.41,195.31 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeTerminal);
export default __webpack_public_path__ + "static/media/icone-terminal.e7559d0cc6e6830e12f8565b7cc9ee55.svg";
export { ForwardRef as ReactComponent };